import { memberGQLFields, networkGQLFields, } from '../network/index.js';
import { appGQLFields } from './app.fields.js';
const BASIC_APP_INSTALLAION_FIELDS = {};
const ALL_APP_INSTALLATION_FIELDS = {
    app: 'basic',
    installedBy: 'basic',
    network: 'basic',
};
export const appInstallationGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_APP_INSTALLAION_FIELDS;
    if (fields === 'all')
        fields = ALL_APP_INSTALLATION_FIELDS;
    return `
    appVersion
    context
    createdAt
    id
    installedAt
    permissions
    status
    updatedAt
    ${fields.app
        ? `
      app {
        ${appGQLFields(fields.app)}
      }
    `
        : ``}
    ${fields.installedBy
        ? `
      installedBy {
        ${memberGQLFields(fields.installedBy)}
      }
    `
        : ``}
    ${fields.network
        ? `
      network {
        ${networkGQLFields(fields.network)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=appInstallation.fields.js.map